export enum ExecutionEnum {
  Idle = "IDLE",
  InProgress = "IN_PROGRESS",
  Success = "SUCCESS",
  Error = "ERROR",
}
